<template>
  <section class="contact-information new-report__section">
    <h3 class="new-report__heading">Contact Information</h3>
    <div class="new-report__input-row">
      <label class="new-report__label" for="name">
        Name <span class="new-report__required-marker">*</span>
      </label>
      <input
        id="name"
        :value="name"
        type="text"
        name="name"
        placeholder="name"
        class="new-report__input new-report__input--text"
        required=""
        @keyup="debounceContactInformation"
        @blur="updateContactInformation"
      />
    </div>
    <div class="new-report__input-row">
      <label class="new-report__label" for="email">
        Email <span class="new-report__required-marker">*</span>
      </label>
      <input
        id="email"
        :value="email"
        type="email"
        name="email"
        placeholder="email"
        class="new-report__input new-report__input--text"
        required=""
        @keyup="debounceContactInformation"
        @blur="updateContactInformation"
      />
    </div>
    <div class="new-report__input-row">
      <label class="new-report__label" for="phone">
        Phone <span class="new-report__required-marker">*</span>
      </label>
      <input
        id="phone"
        :value="phone"
        type="tel"
        name="phone"
        placeholder="phone"
        class="new-report__input new-report__input--text"
        required=""
        @keyup="debounceContactInformation"
        @blur="updateContactInformation"
      />
    </div>
  </section>
</template>

<script>
import { mapMutations } from "vuex";
import { debounce } from "lodash";

export default {
  computed: {
    name() {
      return this.$store.state.incidentReport.contactInformation.name;
    },
    email() {
      return this.$store.state.incidentReport.contactInformation.email;
    },
    phone() {
      return this.$store.state.incidentReport.contactInformation.phone;
    },
  },
  methods: {
    updateContactInformation(event) {
      const contactInformation =
        $nuxt.$store.state.incidentReport.contactInformation;
      const string = event.target.value;
      const type = event.target.name;
      contactInformation[type] = string;
      $nuxt.$store.commit(
        "incidentReport/setContactInformation",
        contactInformation
      );
    },
    debounceContactInformation: debounce((event) => {
      const contactInformation =
        $nuxt.$store.state.incidentReport.contactInformation;
      const string = event.target.value;
      const type = event.target.name;
      contactInformation[type] = string;
      $nuxt.$store.commit(
        "incidentReport/setContactInformation",
        contactInformation
      );
    }, 300),
  },
};
</script>
